/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Compliance_Template_Empty_RegexInputs */



/**
* | output |
* | --- |
* | "Add regex patterns to match" |
*
* @param {Compliance_Template_Empty_RegexInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const compliance_template_empty_regex = /** @type {((inputs?: Compliance_Template_Empty_RegexInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Compliance_Template_Empty_RegexInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Fügen Sie Regex-Muster zum Abgleich hinzu")
	return /** @type {LocalizedString} */ ("Add regex patterns to match")
});